var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"form-control",attrs:{"id":`${_vm.id}-input`,"aria-describedby":`help-${_vm.id}`,"required":!!_vm.required,"readonly":!!_vm.readonly,"placeholder":_vm.placeholder,"maxlength":(_vm.formItem.max) ? _vm.formItem.max : '',"name":_vm.dataName,"value":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }